<template>
  <div>
    <button @click="showModal = true" style="z-index: 9;">
      Show Media Gallery
    </button>
    <MediaGalleryModal
      v-if="showModal"
      @response="handleResponse"
      @close="handleCloseMedia"
    />
  </div>
</template>

<script>
import MediaGalleryModal from "@/components/media-gallery/MediaGalleryModal";
export default {
  components: {
    MediaGalleryModal
  },
  data() {
    return {
      media: {},
      showModal: false
    };
  },
  methods: {
    handleResponse(obj) {
      this.media = obj;
    },
    handleCloseMedia() {
      this.showModal = false;
    }
  }
};
</script>

<style></style>
